(function () {
  'use strict';

  if (window.krtitikaHomepageSizeSelectorReady) return;
  window.krtitikaHomepageSizeSelectorReady = true;

  var active = null;

  function parseJson(script) {
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.warn('[krtitika size selector] Invalid product data', error);
      return [];
    }
  }

  function availableSizes(trigger) {
    var holder = trigger.closest('[data-krtitika-size-product]');
    var script = holder && holder.querySelector('[data-krtitika-variants]');
    var names = [];
    try {
      names = JSON.parse(holder.getAttribute('data-option-names') || '[]');
    } catch (error) {
      names = [];
    }
    var sizeIndex = names.findIndex(function (name) { return /size/i.test(name); });
    var seen = {};
    return parseJson(script).filter(function (variant) {
      return variant.available;
    }).map(function (variant) {
      var label = sizeIndex >= 0 && variant.options ? variant.options[sizeIndex] : variant.title;
      if (!label || label === 'Default Title') label = 'One Size';
      return {
        id: String(variant.id),
        label: String(label),
        price: Number(variant.price || 0),
        priceFormatted: String(variant.priceFormatted || '')
      };
    }).filter(function (variant) {
      if (seen[variant.label]) return false;
      seen[variant.label] = true;
      return true;
    });
  }

  function focusable(modal) {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), [tabindex]:not([tabindex="-1"])'),
      function (element) { return element.offsetParent !== null; }
    );
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('krtitika-size-selector-open');
    window.setTimeout(function () {
      modal.hidden = true;
      if (active && active.trigger) active.trigger.focus();
      active = null;
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220);
  }

  function openModal(trigger) {
    var scope = trigger.closest('[data-krtitika-size-scope]');
    var modal = scope && scope.querySelector('[data-krtitika-size-modal]');
    if (!modal) return;

    var variants = availableSizes(trigger);
    var title = modal.querySelector('[data-size-product-title]');
    var price = modal.querySelector('[data-size-product-price]');
    var options = modal.querySelector('[data-size-options]');
    var confirm = modal.querySelector('[data-size-confirm]');
    var status = modal.querySelector('[data-size-status]');
    var firstVariant = variants[0] || null;

    title.textContent = trigger.getAttribute('data-product-title') || 'Select a size';
    price.textContent = firstVariant ? firstVariant.priceFormatted : '';
    options.innerHTML = '';
    confirm.disabled = !firstVariant;
    confirm.textContent = 'Add to Bag';
    status.textContent = '';
    active = {
      modal: modal,
      trigger: trigger,
      variantId: firstVariant ? firstVariant.id : '',
      variants: variants
    };

    variants.forEach(function (variant, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'krtitika-size-selector__option';
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      button.setAttribute('data-size-option', variant.id);
      button.textContent = variant.label;
      options.appendChild(button);
    });

    if (!variants.length) {
      status.textContent = 'This product is currently unavailable.';
    }

    modal.hidden = false;
    document.body.classList.add('krtitika-size-selector-open');
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var first = modal.querySelector('[data-size-option]') || modal.querySelector('[data-size-close]');
      if (first) first.focus();
    });
  }

  function addSelected(modal) {
    if (!active || !active.variantId) return;
    var confirm = modal.querySelector('[data-size-confirm]');
    var status = modal.querySelector('[data-size-status]');
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    confirm.disabled = true;
    confirm.textContent = 'Adding...';
    status.textContent = '';

    var formData = new FormData();
    formData.append('id', active.variantId);
    formData.append('quantity', '1');

    fetch(cartUrl + '/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add selected size');
        return fetch(cartUrl + '.js').then(function (result) { return result.json(); });
      })
      .then(function (cart) {
        closeModal(modal);
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          window.setTimeout(function () {
            drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
          }, 20);
        }
      })
      .catch(function (error) {
        console.warn('[krtitika size selector]', error);
        status.textContent = 'Unable to add this size. Please try again.';
        confirm.disabled = false;
        confirm.textContent = 'Add to Bag';
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-krtitika-size-trigger]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    var option = event.target.closest('[data-size-option]');
    if (option && active && active.modal.contains(option)) {
      active.modal.querySelectorAll('[data-size-option]').forEach(function (button) {
        button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
      });
      active.variantId = option.getAttribute('data-size-option');
      var selectedVariant = active.variants.find(function (variant) {
        return variant.id === active.variantId;
      });
      active.modal.querySelector('[data-size-product-price]').textContent = selectedVariant
        ? selectedVariant.priceFormatted
        : '';
      active.modal.querySelector('[data-size-confirm]').disabled = false;
      active.modal.querySelector('[data-size-status]').textContent = '';
      return;
    }

    var confirm = event.target.closest('[data-size-confirm]');
    if (confirm && active && active.modal.contains(confirm)) {
      addSelected(active.modal);
      return;
    }

    var close = event.target.closest('[data-size-close]');
    if (close) closeModal(close.closest('[data-krtitika-size-modal]'));
  });

  document.addEventListener('keydown', function (event) {
    if (!active || active.modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(active.modal);
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusable(active.modal);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
